export function buildPagination( pageCount: number, page: number ) {
  if (pageCount < 2) return ''

  let htmlArray = []
  let last = 'show'

  htmlArray.push( '<a href="#prevPage" class="arrow prev '+(1==page?'disabled':'')+'"><svg class="icon icon-chevron-left"><use xlink:href="#icon-chevron-left"></use></svg></a>' )
  htmlArray.push( '<div class="page-count">'+page+'/'+pageCount+'</div>' )
  /*
  htmlArray.push( '<a href="#toPage" data-page="1" class="page '+(1==page?'active':'')+'">'+1+'</a>' )
  for (let i = 1; i < pageCount - 1; i++) {
    if (
      pageCount <= 7 ||
      (page <= 4 && i <= 4) ||
      (page >= pageCount-3 && i >= pageCount-5) ||
      Math.abs( i+1-page ) <= 1
    ) {
      htmlArray.push( '<a href="#toPage" data-page="'+(i+1)+'" class="page '+(i+1==page?'active':'')+'">'+(i+1)+'</a>' )
      last = 'show'
    } else if (last == 'show') {
      htmlArray.push( '<div class="ellipsis">&hellip;</div>' )
      last = 'skip'
    }
  }
  htmlArray.push( '<a href="#toPage" data-page="'+pageCount+'" class="page '+(pageCount==page?'active':'')+'">'+pageCount+'</a>' )
  */
  htmlArray.push( '<a href="#nextPage" class="arrow next '+(pageCount==page?'disabled':'')+'"><svg class="icon icon-chevron-right"><use xlink:href="#icon-chevron-right"></use></svg></a>' )

  return htmlArray.join('')
}